import { Person } from './';

export class Result<T> {
  data: T[];
  current_page: number;
  per_page?: number;
  total: number;

  constructor() {
    this.current_page = 0;
    this.per_page = 0;
    this.total = 0;
    this.data = [];
  }
}

export class LoginResult {
  access_token: string;
  expires_in: string;
  user: Person;
  token_type: string;
  refresh_token: string;

  constructor() {
    this.expires_in = '';
    this.access_token = '';
    this.token_type = '';
    this.refresh_token = '';
    this.user = null;
  }
}

export interface IResult<T> {
  data: T[];
  page: number;
  pageSize: number;
  total: number;
}

export interface ResponsePayload<T> {
  status: boolean;
  message: string;
  data?: T;
}

// export class ResponsePayload {
//   status: boolean;
//   message: string;

//   constructor() {
//     this.status = false;
//     this.message = '';
//   }
// }

export class PasswordPayload {
  old_password: string;
  password: string;
  password_confirmation: string;

  constructor() {
    this.old_password = '';
    this.password = '';
    this.password_confirmation = '';
  }
}
